module.exports = {
  district: [
    { id: 466, name: "AHILYANAGAR" },
    { id: 467, name: "Akola" },
    { id: 468, name: "Amravati" },
    { id: 469, name: "Chhatrapati Sambhajinagar" },
    { id: 470, name: "Beed" },
    { id: 471, name: "Bhandara" },
    { id: 472, name: "Buldhana" },
    { id: 473, name: "Chandrapur" },
    { id: 474, name: "Dhule" },
    { id: 475, name: "Gadchiroli" },
    { id: 476, name: "Gondia" },
    { id: 477, name: "Hingoli" },
    { id: 478, name: "Jalgaon" },
    { id: 479, name: "Jalna" },
    { id: 480, name: "Kolhapur" },
    { id: 481, name: "Latur" },
    { id: 483, name: "Mumbai Suburban" },
    { id: 484, name: "Nagpur" },
    { id: 485, name: "Nanded" },
    { id: 486, name: "Nandurbar" },
    { id: 487, name: "Nashik" },
    { id: 488, name: "DHARASHIV" },
    { id: 489, name: "Parbhani" },
    { id: 490, name: "Pune" },
    { id: 491, name: "Raigad" },
    { id: 492, name: "Ratnagiri" },
    { id: 493, name: "Sangli" },
    { id: 494, name: "Satara" },
    { id: 495, name: "Sindhudurg" },
    { id: 496, name: "Solapur" },
    { id: 497, name: "Thane" },
    { id: 498, name: "Wardha" },
    { id: 499, name: "Washim" },
    { id: 500, name: "Yavatmal" },
    { id: 665, name: "Palghar" },
  ]
};
